import { Link } from "react-router-dom";

import { getGlofoxBrandLogoMarkHref } from "@/lib/portal/glofox-brand";

type GlofoxBrandLogoVariant = "nav" | "card";

interface GlofoxBrandLogoProps {
  /** In-app React Router path. Ignored when `href` is set. */
  to?: string;
  /** Absolute or same-origin URL (e.g. Markdoc docs home). Prefer over `to` for external destinations. */
  href?: string;
  testId?: string;
  className?: string;
  variant?: GlofoxBrandLogoVariant;
}

export function GlofoxBrandLogo({
  to = "/glofox",
  href,
  testId = "gf-nav-glofox-logo",
  className,
  variant = "nav",
}: GlofoxBrandLogoProps) {
  const logoClassName = [
    "glofox-brand-logo",
    variant === "nav" ? "glofox-brand-logo--nav" : "glofox-brand-logo--card",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const content = (
    <>
      <img
        src={getGlofoxBrandLogoMarkHref()}
        alt=""
        className="glofox-brand-logo__img"
        width={variant === "nav" ? 22 : 28}
        height={variant === "nav" ? 22 : 28}
        decoding="async"
      />
      <span className="glofox-brand-logo__label">Glofox</span>
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        className={logoClassName}
        data-testid={testId}
        aria-label="Glofox developer documentation"
      >
        {content}
      </a>
    );
  }

  if (!to) {
    return (
      <span className={logoClassName} data-testid={testId} aria-label="Glofox">
        {content}
      </span>
    );
  }

  return (
    <Link
      to={to}
      className={logoClassName}
      data-testid={testId}
      aria-label="Glofox developer documentation"
    >
      {content}
    </Link>
  );
}
